import mockNations from './mockNations';
import mockCategories from './mockCategories';

// Funktion zum Generieren zufälliger Teilnehmer
const generateMockParticipants = () => {
  const participants = [];
  let nationIdCounter = 1; // Zähler für Nation-ID-Bereiche

  // Deutsche Vornamen für mehr Vielfalt
  const firstNames = [
    "Max", "Anna", "Lucas", "Emma", "Felix", "Sophie", "Leon", "Mia", "Paul", "Lena",
    "Jonas", "Hannah", "Tim", "Lea", "Niklas", "Sarah", "Jan", "Lisa", "Tom", "Laura",
    "David", "Julia", "Sebastian", "Katharina", "Alexander", "Nina", "Christian", "Melanie",
    "Daniel", "Stefanie", "Michael", "Claudia", "Andreas", "Sandra", "Markus", "Petra",
    "Stefan", "Monika", "Thomas", "Angela", "Frank", "Brigitte", "Peter", "Renate"
  ];

  // Deutsche Nachnamen
  const lastNames = [
    "Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker",
    "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf",
    "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann",
    "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann",
    "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer",
    "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß"
  ];

  // Altersgruppen
  const ageGroups = ["Kinder", "Jugend", "Erwachsene", "Senioren", "Senioren Plus"];

  // Geschlechter
  const genders = ["männlich", "weiblich"];

  // Status-Optionen
  const statuses = ["Bestätigt", "Ausstehend"];

  // Funktion zum Generieren eines zufälligen Alters basierend auf Altersgruppe
  const getRandomAge = (ageGroup) => {
    switch (ageGroup) {
      case "Kinder":
        return Math.floor(Math.random() * 6) + 8; // 8-13 Jahre
      case "Jugend":
        return Math.floor(Math.random() * 6) + 14; // 14-19 Jahre
      case "Erwachsene":
        return Math.floor(Math.random() * 20) + 20; // 20-39 Jahre
      case "Senioren":
        return Math.floor(Math.random() * 15) + 40; // 40-54 Jahre
      case "Senioren Plus":
        return Math.floor(Math.random() * 20) + 55; // 55+ Jahre
      default:
        return Math.floor(Math.random() * 30) + 18; // 18-47 Jahre
    }
  };

  // Funktion zum Auswählen zufälliger Kategorien (1-3) basierend auf Altersgruppe
  const getRandomCategories = (ageGroup) => {
    // Finde alle Kategorien, die für diese Altersgruppe verfügbar sind
    const availableCategories = mockCategories.filter(category => 
      category.ageGroups.includes(ageGroup)
    );
    
    if (availableCategories.length === 0) {
      return []; // Keine Kategorien verfügbar
    }
    
    // Wähle 1-3 Kategorien aus den verfügbaren
    const numCategories = Math.min(
      Math.floor(Math.random() * 3) + 1, // 1-3 Kategorien
      availableCategories.length // Nicht mehr als verfügbar
    );
    
    const shuffled = [...availableCategories].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, numCategories).map(cat => cat.name);
  };

  // Für jede Nation Teilnehmer generieren
  mockNations.forEach(nation => {
    // Zufällige Anzahl von Teilnehmern pro Nation (1-10)
    const numParticipants = Math.floor(Math.random() * 30) + 10;
    
    // ID-Bereich für diese Nation (z.B. Deutschland: 100-199, Schweiz: 200-299)
    const nationIdBase = nationIdCounter * 100;
    let athleteCounter = 1;
    
    for (let i = 0; i < numParticipants; i++) {
      const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
      const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
      const ageGroup = ageGroups[Math.floor(Math.random() * ageGroups.length)];
      const gender = genders[Math.floor(Math.random() * genders.length)];
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      
      // ID = Nation-Basis + Athleten-Nummer (z.B. Deutschland: 101, 102, 103...)
      const participantId = nationIdBase + athleteCounter;
      
      // Kategorien basierend auf Altersgruppe zuweisen
      const categories = getRandomCategories(ageGroup);
      
      const participant = {
        id: participantId,
        name: `${firstName} ${lastName}`,
        nation: nation.name,
        nationCode: nation.code,
        age: getRandomAge(ageGroup),
        ageGroup: ageGroup,
        category: categories,
        gender: gender,
        status: status
      };
      
      participants.push(participant);
      athleteCounter++;
    }
    
    // Erhöhe Nation-ID-Zähler für die nächste Nation
    nationIdCounter++;
  });

  return participants;
};

const mockParticipants = generateMockParticipants();

export default mockParticipants; 